import { Box, Text } from '@zillow/constellation-10';
import type { QuartileData } from '../RenterDataReport.utils';

type QuartileCardGridProps = {
  data: Array<QuartileData>;
};

export const QuartileCardGrid = ({ data }: QuartileCardGridProps) => {
  return (
    <Box
      css={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: '400',
      }}
    >
      {data.map((item) => (
        <Box
          key={item.label}
          css={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '400',
            border: '1px solid',
            borderColor: 'border.muted',
            borderRadius: '200',
            height: '110px',
            gap: '200',
          }}
        >
          <Text textStyle="body-sm" css={{ color: 'text.subtle', textAlign: 'center' }}>
            {item.label}
          </Text>
          <Text textStyle="heading-sm" css={{ textAlign: 'center', whiteSpace: 'pre-line' }}>
            {item.value}
          </Text>
        </Box>
      ))}
    </Box>
  );
};
